import Image from "next/image";

export default function TelContactItem(props) {
  const { item } = props;
  return (
    <address className="flex flex-col w-full gap-2 relative">
      <h3 className="font-bold uppercase text-gray-700">{item.title}</h3>
      <div className="flex w-full h-full gap-4 relative items-center">
        <Image
          src="/svgs/phone-call-icon.svg"
          alt="icon"
          objectFit="contain"
          layout="fixed"
          width={20}
          height={18}
        />
        <div className="flex flex-col gap-2">
          <a
            href={`tel:${item.contentOne}`}
            className="text-gray-500 underline decoration-gray-200 transition-colors hover:text-red-main"
          >
            {item.contentOne}
          </a>
        </div>
      </div>
    </address>
  );
}
